import { VIEW_WIDGET_ONLY } from 'actions';

export function setViewWidgetOnly(widgetViewMode: string) {
  return {
    isViewWidgetOnly: widgetViewMode === 'page',
    type: VIEW_WIDGET_ONLY,
  };
}
